import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import {  Observable} from 'rxjs';
import * as _ from 'lodash';
import { EndpointConfig } from "src/app/config/endpoint-config";
import { NGXLogger } from "ngx-logger";
import { ImageRequestRegisterModel } from "src/app/component/image-request-register-dialog/image-request-register-dialog.component";
import { ImageRequest } from "src/app/model/imageRequest/imageRequest";


@Injectable()
export class ImageRequestApiService {

  constructor(
    private http: HttpClient,
    private endpointConfig: EndpointConfig,
    private logger: NGXLogger,
  ) {

  }

  // ------------------------
  // Request API section
  // ------------------------

    addImageRequest(payload: ImageRequestRegisterModel): Observable<ImageRequest> {
        let url = this.endpointConfig.riaApi.imageRequests.getUrl()
        return this.http.post<ImageRequest>(url, payload)
    }

  }